"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _TransformationToolsManager_eventEngine, _TransformationToolsManager_id, _TransformationToolsManager_keysPressed, _TransformationToolsManager_matrixId, _TransformationToolsManager_nodes, _TransformationToolsManager_parentObject, _TransformationToolsManager_restrictionManager, _TransformationToolsManager_singleNode, _TransformationToolsManager_uuidGenerator, _TransformationToolsManager_viewport, _TransformationToolsManager_cameraFreezeFlag, _TransformationToolsManager_canvasEventListenerToken, _TransformationToolsManager_closed, _TransformationToolsManager_continuousRenderingFlag, _TransformationToolsManager_continuousShadowMapUpdateFlag, _TransformationToolsManager_initialOffset, _TransformationToolsManager_initialTransform, _TransformationToolsManager_instanceTransform, _TransformationToolsManager_pivotOffset, _TransformationToolsManager_previousTransformationToolsMatrix, _TransformationToolsManager_reuseTransformation, _TransformationToolsManager_settings, _TransformationToolsManager_show;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformationToolsManager = void 0;
const THREE = __importStar(require("three"));
const viewer_1 = require("@shapediver/viewer");
const viewer_rendering_engine_intersection_restriction_engine_1 = require("@shapediver/viewer.rendering-engine.intersection-restriction-engine");
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const gl_matrix_1 = require("gl-matrix");
class TransformationToolsManager {
    constructor(id, viewport, nodes, settings) {
        var _a;
        _TransformationToolsManager_eventEngine.set(this, viewer_shared_services_1.EventEngine.instance);
        _TransformationToolsManager_id.set(this, void 0);
        _TransformationToolsManager_keysPressed.set(this, {});
        _TransformationToolsManager_matrixId.set(this, "SD_transformation_tools_matrix");
        _TransformationToolsManager_nodes.set(this, []);
        _TransformationToolsManager_parentObject.set(this, new THREE.Object3D());
        _TransformationToolsManager_restrictionManager.set(this, void 0);
        _TransformationToolsManager_singleNode.set(this, void 0);
        _TransformationToolsManager_uuidGenerator.set(this, viewer_shared_services_1.UuidGenerator.instance);
        _TransformationToolsManager_viewport.set(this, void 0);
        _TransformationToolsManager_cameraFreezeFlag.set(this, void 0);
        _TransformationToolsManager_canvasEventListenerToken.set(this, void 0);
        _TransformationToolsManager_closed.set(this, false);
        _TransformationToolsManager_continuousRenderingFlag.set(this, void 0);
        _TransformationToolsManager_continuousShadowMapUpdateFlag.set(this, void 0);
        _TransformationToolsManager_initialOffset.set(this, gl_matrix_1.vec3.create());
        _TransformationToolsManager_initialTransform.set(this, []);
        _TransformationToolsManager_instanceTransform.set(this, []);
        _TransformationToolsManager_pivotOffset.set(this, gl_matrix_1.mat4.create());
        _TransformationToolsManager_previousTransformationToolsMatrix.set(this, []);
        _TransformationToolsManager_reuseTransformation.set(this, true);
        _TransformationToolsManager_settings.set(this, void 0);
        _TransformationToolsManager_show.set(this, true);
        __classPrivateFieldSet(this, _TransformationToolsManager_id, id !== null && id !== void 0 ? id : __classPrivateFieldGet(this, _TransformationToolsManager_uuidGenerator, "f").create(), "f");
        __classPrivateFieldSet(this, _TransformationToolsManager_viewport, viewport, "f");
        __classPrivateFieldSet(this, _TransformationToolsManager_canvasEventListenerToken, __classPrivateFieldGet(this, _TransformationToolsManager_viewport, "f").addCanvasEventListener(this), "f");
        __classPrivateFieldSet(this, _TransformationToolsManager_nodes, nodes, "f");
        __classPrivateFieldSet(this, _TransformationToolsManager_singleNode, nodes.length === 1, "f");
        __classPrivateFieldSet(this, _TransformationToolsManager_settings, settings, "f");
        if (__classPrivateFieldGet(this, _TransformationToolsManager_singleNode, "f") && (settings === null || settings === void 0 ? void 0 : settings.restrictions) !== undefined) {
            const restrictionsArray = [];
            for (const restrictionId in settings.restrictions) {
                const restriction = settings.restrictions[restrictionId];
                if (!restriction)
                    continue;
                if (!restriction.id)
                    restriction.id = restrictionId;
                restrictionsArray.push(restriction);
            }
            __classPrivateFieldSet(this, _TransformationToolsManager_restrictionManager, new viewer_rendering_engine_intersection_restriction_engine_1.RestrictionManager(viewport, undefined, restrictionsArray), "f");
        }
        // we don't allow to change the reuseTransformation for now
        __classPrivateFieldSet(this, _TransformationToolsManager_reuseTransformation, (_a = settings === null || settings === void 0 ? void 0 : settings.reuseTransformation) !== null && _a !== void 0 ? _a : true, "f");
    }
    get closed() {
        return __classPrivateFieldGet(this, _TransformationToolsManager_closed, "f");
    }
    get id() {
        return __classPrivateFieldGet(this, _TransformationToolsManager_id, "f");
    }
    get settings() {
        return __classPrivateFieldGet(this, _TransformationToolsManager_settings, "f");
    }
    get show() {
        return __classPrivateFieldGet(this, _TransformationToolsManager_show, "f");
    }
    set show(value) {
        __classPrivateFieldSet(this, _TransformationToolsManager_show, value, "f");
    }
    get canvasEventListenerToken() {
        return __classPrivateFieldGet(this, _TransformationToolsManager_canvasEventListenerToken, "f");
    }
    get initialOffset() {
        return __classPrivateFieldGet(this, _TransformationToolsManager_initialOffset, "f");
    }
    get initialTransform() {
        return __classPrivateFieldGet(this, _TransformationToolsManager_initialTransform, "f");
    }
    get instanceTransform() {
        return __classPrivateFieldGet(this, _TransformationToolsManager_instanceTransform, "f");
    }
    get keysPressed() {
        return __classPrivateFieldGet(this, _TransformationToolsManager_keysPressed, "f");
    }
    get nodes() {
        return __classPrivateFieldGet(this, _TransformationToolsManager_nodes, "f");
    }
    get parentObject() {
        return __classPrivateFieldGet(this, _TransformationToolsManager_parentObject, "f");
    }
    get pivotOffset() {
        return __classPrivateFieldGet(this, _TransformationToolsManager_pivotOffset, "f");
    }
    get previousTransformationToolsMatrix() {
        return __classPrivateFieldGet(this, _TransformationToolsManager_previousTransformationToolsMatrix, "f");
    }
    get restrictionManager() {
        return __classPrivateFieldGet(this, _TransformationToolsManager_restrictionManager, "f");
    }
    get reuseTransformation() {
        return __classPrivateFieldGet(this, _TransformationToolsManager_reuseTransformation, "f");
    }
    get singleNode() {
        return __classPrivateFieldGet(this, _TransformationToolsManager_singleNode, "f");
    }
    get viewport() {
        return __classPrivateFieldGet(this, _TransformationToolsManager_viewport, "f");
    }
    close() {
        __classPrivateFieldSet(this, _TransformationToolsManager_closed, true, "f");
        this.closeLogic();
        __classPrivateFieldGet(this, _TransformationToolsManager_viewport, "f").removeCanvasEventListener(__classPrivateFieldGet(this, _TransformationToolsManager_canvasEventListenerToken, "f"));
        if (__classPrivateFieldGet(this, _TransformationToolsManager_continuousRenderingFlag, "f"))
            __classPrivateFieldGet(this, _TransformationToolsManager_viewport, "f").removeFlag(__classPrivateFieldGet(this, _TransformationToolsManager_continuousRenderingFlag, "f"));
        if (__classPrivateFieldGet(this, _TransformationToolsManager_continuousShadowMapUpdateFlag, "f"))
            __classPrivateFieldGet(this, _TransformationToolsManager_viewport, "f").removeFlag(__classPrivateFieldGet(this, _TransformationToolsManager_continuousShadowMapUpdateFlag, "f"));
        if (__classPrivateFieldGet(this, _TransformationToolsManager_cameraFreezeFlag, "f"))
            __classPrivateFieldGet(this, _TransformationToolsManager_viewport, "f").removeFlag(__classPrivateFieldGet(this, _TransformationToolsManager_cameraFreezeFlag, "f"));
    }
    keyPressed(key) {
        if (Array.isArray(key)) {
            // check if one of the keys is pressed
            let result = false;
            for (let i = 0; i < key.length; i++) {
                result = result || this.keyPressCheck(key[i]);
            }
            return result;
        }
        else {
            return this.keyPressCheck(key);
        }
    }
    onKeyDown(event, pointerInCanvas) {
        if (this.closed)
            return;
        if (!pointerInCanvas)
            return;
        __classPrivateFieldGet(this, _TransformationToolsManager_keysPressed, "f")[event.key] = true;
        this.onKeyDownLogic(event, pointerInCanvas);
    }
    onKeyUp(event, pointerInCanvas) {
        if (this.closed)
            return;
        delete __classPrivateFieldGet(this, _TransformationToolsManager_keysPressed, "f")[event.key];
        this.onKeyUpLogic(event, pointerInCanvas);
    }
    onMouseWheel(event) { }
    onPointerDown(event) {
        if (this.closed)
            return;
        this.onPointerDownLogic(event);
    }
    onPointerEnd(event) {
        if (this.closed)
            return;
        this.onPointerEndLogic(event);
    }
    onPointerMove(event) {
        if (this.closed)
            return;
        if (!__classPrivateFieldGet(this, _TransformationToolsManager_continuousRenderingFlag, "f"))
            __classPrivateFieldSet(this, _TransformationToolsManager_continuousRenderingFlag, __classPrivateFieldGet(this, _TransformationToolsManager_viewport, "f").addFlag(viewer_shared_types_1.FLAG_TYPE.CONTINUOUS_RENDERING), "f");
        if (!__classPrivateFieldGet(this, _TransformationToolsManager_continuousShadowMapUpdateFlag, "f"))
            __classPrivateFieldSet(this, _TransformationToolsManager_continuousShadowMapUpdateFlag, __classPrivateFieldGet(this, _TransformationToolsManager_viewport, "f").addFlag(viewer_shared_types_1.FLAG_TYPE.CONTINUOUS_SHADOW_MAP_UPDATE), "f");
        this.onPointerMoveLogic(event);
    }
    onPointerOut(event) {
        if (this.closed)
            return;
        if (__classPrivateFieldGet(this, _TransformationToolsManager_continuousRenderingFlag, "f")) {
            __classPrivateFieldGet(this, _TransformationToolsManager_viewport, "f").removeFlag(__classPrivateFieldGet(this, _TransformationToolsManager_continuousRenderingFlag, "f"));
            __classPrivateFieldSet(this, _TransformationToolsManager_continuousRenderingFlag, undefined, "f");
        }
        if (__classPrivateFieldGet(this, _TransformationToolsManager_continuousShadowMapUpdateFlag, "f")) {
            __classPrivateFieldGet(this, _TransformationToolsManager_viewport, "f").removeFlag(__classPrivateFieldGet(this, _TransformationToolsManager_continuousShadowMapUpdateFlag, "f"));
            __classPrivateFieldSet(this, _TransformationToolsManager_continuousShadowMapUpdateFlag, undefined, "f");
        }
        __classPrivateFieldGet(this, _TransformationToolsManager_viewport, "f").render();
        this.onPointerOutLogic(event);
    }
    onPointerUp(event) {
        if (this.closed)
            return;
        this.onPointerUpLogic(event);
    }
    getMatrix(previousMatrix, instanceMatrix) {
        const placeholderMatrix = gl_matrix_1.mat4.copy(gl_matrix_1.mat4.create(), this.transformationToolsPlaceholderMatrix);
        const initialOffsetCorrectionMatrix = gl_matrix_1.mat4.fromTranslation(gl_matrix_1.mat4.create(), gl_matrix_1.vec3.negate(gl_matrix_1.vec3.create(), this.initialOffset));
        const placeholderMatrixWithoutInitialOffset = gl_matrix_1.mat4.multiply(gl_matrix_1.mat4.create(), placeholderMatrix, initialOffsetCorrectionMatrix);
        const matrix = gl_matrix_1.mat4.clone(placeholderMatrixWithoutInitialOffset);
        if (this.singleNode === true) {
            if (this.reuseTransformation === true) {
                const finalMatrix = gl_matrix_1.mat4.create();
                gl_matrix_1.mat4.multiply(finalMatrix, placeholderMatrixWithoutInitialOffset, gl_matrix_1.mat4.invert(gl_matrix_1.mat4.create(), __classPrivateFieldGet(this, _TransformationToolsManager_pivotOffset, "f")));
                return finalMatrix;
            }
            else {
                const finalMatrix = gl_matrix_1.mat4.create();
                gl_matrix_1.mat4.multiply(finalMatrix, placeholderMatrixWithoutInitialOffset, gl_matrix_1.mat4.invert(gl_matrix_1.mat4.create(), __classPrivateFieldGet(this, _TransformationToolsManager_pivotOffset, "f")));
                gl_matrix_1.mat4.multiply(finalMatrix, finalMatrix, previousMatrix);
                return finalMatrix;
            }
        }
        else {
            const finalMatrix = gl_matrix_1.mat4.create();
            gl_matrix_1.mat4.multiply(placeholderMatrixWithoutInitialOffset, placeholderMatrixWithoutInitialOffset, instanceMatrix);
            gl_matrix_1.mat4.multiply(finalMatrix, placeholderMatrixWithoutInitialOffset, gl_matrix_1.mat4.invert(gl_matrix_1.mat4.create(), __classPrivateFieldGet(this, _TransformationToolsManager_pivotOffset, "f")));
            gl_matrix_1.mat4.multiply(finalMatrix, finalMatrix, previousMatrix);
            return finalMatrix;
        }
    }
    initialize() {
        const transformationPlaceholderMatrix = gl_matrix_1.mat4.create();
        // assign the position to the transformation tools objects
        if (__classPrivateFieldGet(this, _TransformationToolsManager_singleNode, "f")) {
            const index = __classPrivateFieldGet(this, _TransformationToolsManager_nodes, "f")[0].transformations.findIndex((t) => t.id === "SD_transformation_tools_matrix");
            if (index !== -1) {
                __classPrivateFieldGet(this, _TransformationToolsManager_previousTransformationToolsMatrix, "f")[0] = gl_matrix_1.mat4.clone(__classPrivateFieldGet(this, _TransformationToolsManager_nodes, "f")[0].transformations[index].matrix);
            }
            else {
                __classPrivateFieldGet(this, _TransformationToolsManager_previousTransformationToolsMatrix, "f")[0] = gl_matrix_1.mat4.create();
            }
            if (this.reuseTransformation === true) {
                const trueBB = new viewer_1.Box();
                __classPrivateFieldGet(this, _TransformationToolsManager_nodes, "f")[0].traverseData((d) => {
                    if (d instanceof viewer_shared_node_tree_1.GeometryData) {
                        trueBB.union(d.boundingBox);
                    }
                });
                gl_matrix_1.vec3.copy(__classPrivateFieldGet(this, _TransformationToolsManager_initialOffset, "f"), trueBB.boundingSphere.center);
                gl_matrix_1.mat4.fromTranslation(transformationPlaceholderMatrix, __classPrivateFieldGet(this, _TransformationToolsManager_initialOffset, "f"));
                {
                    const transformations = {};
                    __classPrivateFieldGet(this, _TransformationToolsManager_nodes, "f")[0].traverse((c) => {
                        if (c.data.find((d) => d instanceof viewer_shared_node_tree_1.GeometryData))
                            transformations[c.name] = gl_matrix_1.mat4.clone(c.nodeMatrix);
                    });
                    if (Object.keys(transformations).length === 1 &&
                        Object.keys(transformations)[0] !== "no_transformations") {
                        __classPrivateFieldGet(this, _TransformationToolsManager_initialTransform, "f")[0] = gl_matrix_1.mat4.clone(transformations[Object.keys(transformations)[0]]);
                        const initialWorldTransform = gl_matrix_1.mat4.multiply(gl_matrix_1.mat4.create(), __classPrivateFieldGet(this, _TransformationToolsManager_nodes, "f")[0].worldMatrix, __classPrivateFieldGet(this, _TransformationToolsManager_initialTransform, "f")[0]);
                        gl_matrix_1.mat4.multiply(transformationPlaceholderMatrix, initialWorldTransform, transformationPlaceholderMatrix);
                    }
                    else {
                        __classPrivateFieldGet(this, _TransformationToolsManager_initialTransform, "f")[0] = gl_matrix_1.mat4.create();
                        gl_matrix_1.mat4.multiply(transformationPlaceholderMatrix, __classPrivateFieldGet(this, _TransformationToolsManager_nodes, "f")[0].worldMatrix, transformationPlaceholderMatrix);
                    }
                }
                {
                    // the structure is as follows:
                    // sessionNode -> instanceNode -> transformations
                    // therefore we first find the the node with the name "transformations[*]"
                    // and then check if the parent of its parent is the sessionNode
                    let currentNode = __classPrivateFieldGet(this, _TransformationToolsManager_nodes, "f")[0];
                    __classPrivateFieldGet(this, _TransformationToolsManager_instanceTransform, "f")[0] = gl_matrix_1.mat4.create();
                    while (currentNode.parent) {
                        // we have found the transformations node
                        if (new RegExp(/^transformations\[\d+\]$/).test(currentNode.name)) {
                            if (currentNode.parent &&
                                currentNode.parent.parent &&
                                currentNode.parent.parent.data.find((d) => d instanceof viewer_1.SessionApiData)) {
                                // we confirm that this is a proper transformations node of an instance
                                __classPrivateFieldGet(this, _TransformationToolsManager_instanceTransform, "f")[0] = gl_matrix_1.mat4.clone(currentNode.transformations[0].matrix);
                                break;
                            }
                        }
                        currentNode = currentNode.parent;
                    }
                }
            }
            else {
                __classPrivateFieldGet(this, _TransformationToolsManager_initialTransform, "f")[0] = gl_matrix_1.mat4.create();
                gl_matrix_1.vec3.copy(__classPrivateFieldGet(this, _TransformationToolsManager_initialOffset, "f"), __classPrivateFieldGet(this, _TransformationToolsManager_nodes, "f")[0].boundingBox.boundingSphere.center);
                gl_matrix_1.mat4.multiply(transformationPlaceholderMatrix, gl_matrix_1.mat4.fromTranslation(gl_matrix_1.mat4.create(), __classPrivateFieldGet(this, _TransformationToolsManager_initialOffset, "f")), transformationPlaceholderMatrix);
            }
        }
        else {
            const boundingBox = new viewer_1.Box();
            __classPrivateFieldSet(this, _TransformationToolsManager_previousTransformationToolsMatrix, [], "f");
            for (let i = 0; i < __classPrivateFieldGet(this, _TransformationToolsManager_nodes, "f").length; i++) {
                const node = __classPrivateFieldGet(this, _TransformationToolsManager_nodes, "f")[i];
                boundingBox.union(node.boundingBox);
                const index = node.transformations.findIndex((t) => t.id === "SD_transformation_tools_matrix");
                if (index !== -1) {
                    __classPrivateFieldGet(this, _TransformationToolsManager_previousTransformationToolsMatrix, "f").push(gl_matrix_1.mat4.clone(node.transformations[index].matrix));
                }
                else {
                    __classPrivateFieldGet(this, _TransformationToolsManager_previousTransformationToolsMatrix, "f").push(gl_matrix_1.mat4.create());
                }
                {
                    const transformations = {};
                    node.traverse((c) => {
                        if (c.data.find((d) => d instanceof viewer_shared_node_tree_1.GeometryData)) {
                            transformations[c.name] = gl_matrix_1.mat4.clone(c.nodeMatrix);
                        }
                    });
                    if (Object.keys(transformations).length === 1 &&
                        Object.keys(transformations)[0] !== "no_transformations") {
                        __classPrivateFieldGet(this, _TransformationToolsManager_initialTransform, "f")[i] = gl_matrix_1.mat4.clone(transformations[Object.keys(transformations)[0]]);
                    }
                    else {
                        __classPrivateFieldGet(this, _TransformationToolsManager_initialTransform, "f")[i] = gl_matrix_1.mat4.create();
                    }
                }
                {
                    // the structure is as follows:
                    // sessionNode -> instanceNode -> transformations
                    // therefore we first find the the node with the name "transformations[*]"
                    // and then check if the parent of its parent is the sessionNode
                    let currentNode = node;
                    __classPrivateFieldGet(this, _TransformationToolsManager_instanceTransform, "f")[i] = gl_matrix_1.mat4.create();
                    while (currentNode.parent) {
                        // we have found the transformations node
                        if (new RegExp(/^transformations\[\d+\]$/).test(currentNode.name)) {
                            if (currentNode.parent &&
                                currentNode.parent.parent &&
                                currentNode.parent.parent.data.find((d) => d instanceof viewer_1.SessionApiData)) {
                                // we confirm that this is a proper transformations node of an instance
                                __classPrivateFieldGet(this, _TransformationToolsManager_instanceTransform, "f")[i] = gl_matrix_1.mat4.clone(currentNode.transformations[0].matrix);
                                break;
                            }
                        }
                        currentNode = currentNode.parent;
                    }
                }
            }
            gl_matrix_1.vec3.copy(__classPrivateFieldGet(this, _TransformationToolsManager_initialOffset, "f"), boundingBox.boundingSphere.center);
            gl_matrix_1.mat4.multiply(transformationPlaceholderMatrix, gl_matrix_1.mat4.fromTranslation(gl_matrix_1.mat4.create(), __classPrivateFieldGet(this, _TransformationToolsManager_initialOffset, "f")), transformationPlaceholderMatrix);
        }
        return transformationPlaceholderMatrix;
    }
    onKeyDownLogic(_event, _pointerInCanvas) { }
    onKeyUpLogic(_event, _pointerInCanvas) { }
    onPointerDownLogic(_event) { }
    onPointerEndLogic(_event) { }
    onPointerMoveLogic(_event) { }
    onPointerOutLogic(_event) { }
    onPointerUpLogic(_event) { }
    toggleCameraFreeze(freeze) {
        if (freeze) {
            if (!__classPrivateFieldGet(this, _TransformationToolsManager_cameraFreezeFlag, "f"))
                __classPrivateFieldSet(this, _TransformationToolsManager_cameraFreezeFlag, __classPrivateFieldGet(this, _TransformationToolsManager_viewport, "f").addFlag(viewer_shared_types_1.FLAG_TYPE.CAMERA_FREEZE), "f");
        }
        else {
            if (__classPrivateFieldGet(this, _TransformationToolsManager_cameraFreezeFlag, "f")) {
                __classPrivateFieldGet(this, _TransformationToolsManager_viewport, "f").removeFlag(__classPrivateFieldGet(this, _TransformationToolsManager_cameraFreezeFlag, "f"));
                __classPrivateFieldSet(this, _TransformationToolsManager_cameraFreezeFlag, undefined, "f");
            }
        }
    }
    updateObjectMatrices() {
        const eventData = {
            viewportId: this.viewport.id,
            transformations: [],
            localTransformations: [],
            nodes: [],
            id: this.id,
            type: this.type,
        };
        this.nodes.forEach((node, i) => {
            const matrix = this.getMatrix(this.previousTransformationToolsMatrix[i], this.instanceTransform[i]);
            eventData.nodes.push(node);
            if (this.singleNode) {
                gl_matrix_1.mat4.multiply(matrix, gl_matrix_1.mat4.invert(gl_matrix_1.mat4.create(), this.instanceTransform[i]), matrix);
                eventData.transformations.push(gl_matrix_1.mat4.clone(matrix));
                gl_matrix_1.mat4.multiply(matrix, matrix, gl_matrix_1.mat4.invert(gl_matrix_1.mat4.create(), this.initialTransform[i]));
            }
            else {
                const eventDataMatrix = gl_matrix_1.mat4.clone(matrix);
                gl_matrix_1.mat4.multiply(eventDataMatrix, eventDataMatrix, this.initialTransform[i]);
                gl_matrix_1.mat4.multiply(eventDataMatrix, gl_matrix_1.mat4.invert(gl_matrix_1.mat4.create(), this.instanceTransform[i]), eventDataMatrix);
                eventData.transformations.push(eventDataMatrix);
                gl_matrix_1.mat4.multiply(matrix, gl_matrix_1.mat4.invert(gl_matrix_1.mat4.create(), this.instanceTransform[i]), matrix);
            }
            const transformation = node.transformations.find((t) => t.id === __classPrivateFieldGet(this, _TransformationToolsManager_matrixId, "f"));
            eventData.localTransformations.push(gl_matrix_1.mat4.clone(matrix));
            if (transformation) {
                transformation.matrix = matrix;
            }
            else {
                node.transformations.push({
                    id: __classPrivateFieldGet(this, _TransformationToolsManager_matrixId, "f"),
                    matrix,
                });
            }
            node.updateVersion();
        });
        // emit the event
        __classPrivateFieldGet(this, _TransformationToolsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_TRANSFORMATION_TOOLS.MATRIX_CHANGED, eventData);
    }
    updateObjects() {
        this.nodes.forEach((node, i) => {
            const threeJsObject = node
                .convertedObject[this.viewport.id];
            if (threeJsObject) {
                const matrix = this.getMatrix(this.previousTransformationToolsMatrix[i], this.instanceTransform[i]);
                if (this.singleNode) {
                    gl_matrix_1.mat4.multiply(matrix, gl_matrix_1.mat4.invert(gl_matrix_1.mat4.create(), this.instanceTransform[i]), matrix);
                    gl_matrix_1.mat4.multiply(matrix, matrix, gl_matrix_1.mat4.invert(gl_matrix_1.mat4.create(), this.initialTransform[i]));
                }
                else {
                    gl_matrix_1.mat4.multiply(matrix, gl_matrix_1.mat4.invert(gl_matrix_1.mat4.create(), this.instanceTransform[i]), matrix);
                }
                // `matrix` is now the new matrixId value — what updateObjectMatrices
                // would commit. The Three.js SDObject's matrix must equal the full
                // nodeMatrix that a scene-tree rebuild would produce:
                //   nodeMatrix = [other transforms] × matrixId
                // Since matrixId is always the last transformation appended to
                // node.transformations, we recover [other transforms] by dividing out
                // the currently-committed matrixId:
                //   desired = node.nodeMatrix × inv(committedMatrixId) × matrix
                // This preserves any transforms higher up in the node's transformation
                // list (e.g. a scale/rotation applied by a parent node) that are baked
                // into nodeMatrix but absent from `matrix` alone.
                const committedTransform = node.transformations.find((t) => t.id === __classPrivateFieldGet(this, _TransformationToolsManager_matrixId, "f"));
                const committedMatrix = committedTransform
                    ? new THREE.Matrix4().fromArray(committedTransform.matrix)
                    : new THREE.Matrix4();
                const nodeMatrixM4 = new THREE.Matrix4().fromArray(node.nodeMatrix);
                const newMatrixM4 = new THREE.Matrix4().fromArray(matrix);
                const m4 = nodeMatrixM4
                    .multiply(committedMatrix.invert())
                    .multiply(newMatrixM4);
                threeJsObject.matrixAutoUpdate = false;
                threeJsObject.matrix.copy(m4);
                threeJsObject.matrixWorldNeedsUpdate = true;
            }
        });
    }
    keyPressCheck(key) {
        const pressedKeys = Object.keys(__classPrivateFieldGet(this, _TransformationToolsManager_keysPressed, "f")).filter((key) => __classPrivateFieldGet(this, _TransformationToolsManager_keysPressed, "f")[key] === true);
        // check if it the only key that is pressed
        if (key.includes("+") && key.length > 1) {
            const keys = key.split("+");
            // there are more keys pressed than the keys in the combination
            if (keys.length !== pressedKeys.length)
                return false;
            let result = true;
            for (let i = 0; i < keys.length; i++)
                result = result && (__classPrivateFieldGet(this, _TransformationToolsManager_keysPressed, "f")[keys[i]] || false);
            return result;
        }
        else {
            // there are also other keys pressed
            if (pressedKeys.length > 1)
                return false;
            return __classPrivateFieldGet(this, _TransformationToolsManager_keysPressed, "f")[key] || false;
        }
    }
}
exports.TransformationToolsManager = TransformationToolsManager;
_TransformationToolsManager_eventEngine = new WeakMap(), _TransformationToolsManager_id = new WeakMap(), _TransformationToolsManager_keysPressed = new WeakMap(), _TransformationToolsManager_matrixId = new WeakMap(), _TransformationToolsManager_nodes = new WeakMap(), _TransformationToolsManager_parentObject = new WeakMap(), _TransformationToolsManager_restrictionManager = new WeakMap(), _TransformationToolsManager_singleNode = new WeakMap(), _TransformationToolsManager_uuidGenerator = new WeakMap(), _TransformationToolsManager_viewport = new WeakMap(), _TransformationToolsManager_cameraFreezeFlag = new WeakMap(), _TransformationToolsManager_canvasEventListenerToken = new WeakMap(), _TransformationToolsManager_closed = new WeakMap(), _TransformationToolsManager_continuousRenderingFlag = new WeakMap(), _TransformationToolsManager_continuousShadowMapUpdateFlag = new WeakMap(), _TransformationToolsManager_initialOffset = new WeakMap(), _TransformationToolsManager_initialTransform = new WeakMap(), _TransformationToolsManager_instanceTransform = new WeakMap(), _TransformationToolsManager_pivotOffset = new WeakMap(), _TransformationToolsManager_previousTransformationToolsMatrix = new WeakMap(), _TransformationToolsManager_reuseTransformation = new WeakMap(), _TransformationToolsManager_settings = new WeakMap(), _TransformationToolsManager_show = new WeakMap();
//# sourceMappingURL=TransformationToolsManager.js.map